<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue";

const props = defineProps({
  height: {
    type: Number,
    required: true
  },
  timeout: {
    type: Number,
    required: true
  }
});

const timeout = new Date(Date.now() + props.timeout);

const ticker = ref(null);
const percentTime = ref(0);
const timeLeft = ref(0);

const ensurePositive = (p) => Math.max(0, p);

const calculateTimeLeft = (timeout) => {
  const timeLeft = timeout.getTime() - Date.now();

  return ensurePositive(timeLeft);
};

const startProgressBar = () => {
  ticker.value = requestAnimationFrame(progress);
};

const progress = () => {
  timeLeft.value = calculateTimeLeft(timeout);
  percentTime.value = ensurePositive(100 - Math.round((timeLeft.value / props.timeout) * 100));

  if (percentTime.value >= 100) {
    return cancelAnimationFrame(ticker.value);
  }

  startProgressBar();
};

const heightFormatted = computed(() => `${props.height}px`);

onMounted(() => startProgressBar());
onUnmounted(() => cancelAnimationFrame(ticker.value));
</script>

<template>
  <div
    class="timeout-progress-bar"
    role="progressbar"
    :style="{ width: `${percentTime}%` }"
    :aria-valuenow="percentTime"
    aria-valuemin="0"
    aria-valuemax="100"
  ></div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.timeout-progress-bar {
  height: v-bind("heightFormatted");
  background: rgb(@theme-colors[@secondary][base]);
}
</style>
